import { CarouselShared } from "../../../../components/Generales/CarouselShared";
import lep1 from "../../../../assets/landing/lep1.png";
import lep2 from "../../../../assets/landing/lep2.png";
import lep3 from "../../../../assets/landing/lep3.png";
import lep4 from "../../../../assets/landing/lep4.png";

const slides = [
  {
    title: "¿Qué es la Ley del Espectáculo Público (LEP)?",
    content:
      "La Ley del Espectáculo Público (LEP) es una ley que busca apoyar al sector de las artes escénicas en Colombia —eso incluye teatro, danza, música en vivo, circo y más— usando parte del dinero que se recauda en boletería de conciertos, obras y eventos en vivo. ¿Cómo? Redistribuyendo esos recursos para que lleguen a quienes hacen posible el arte: artistas, grupos, salas, colectivos, gestores y productores.",
    content2:
      "¿En qué te beneficia? Gracias a la LEP, se han financiado cosas como: Mejoras en salas y teatros: para que más lugares estén bien equipados y en buen estado. Recursos para producir eventos escénicos: apoyo económico para que pongas en escena esa obra, ese concierto o ese montaje que tanto sueñas. Apoyo para circular: si quieres llevar tu trabajo a otra ciudad, otro país o simplemente a nuevos públicos, la LEP puede darte una mano.",
    image: lep1,
  },
  {
    title: "¿Quién puede participar?",
    content:
      "Artistas, agrupaciones, colectivos, salas de teatro, gestores culturales, productores escénicos… si haces parte del ecosistema del espectáculo en vivo, esta ley te abre la puerta.",
    content2:
      "¿Cómo funciona? Cada vez que alguien compra una boleta para un evento en vivo que sea igual o mayor a $150.000 COP, el 10% de este valor entra a un fondo. Ese fondo luego se usa para convocar, financiar y fortalecer proyectos de artes escénicas. A través de convocatorias públicas, vos podés presentar tu propuesta y postularte para recibir recursos.",
    image: lep2,
  },
  {
    title: "¿Y si nunca he participado?",
    content:
      "No te preocupes. Para eso creamos esta guía y este espacio: para explicarte todo paso a paso, sin enredos, con lenguaje claro, ejemplos y recomendaciones que te pueden servir.",
    content2: "Explora la guía. Conoce cómo aplicar. Y anímate a participar.",
    image: lep3,
  },
  {
    title: "¿Un Comité LEP?",
    content:
      "Sí, el Comité de la Contribución Parafiscal de los Espectáculos Públicos de las Artes Escénicas es la instancia donde se avala la destinación de los recursos, se apoya la administración de estos y se da el visto bueno a las propuestas que serán beneficiados con los recursos LEP.",
    image: lep4,
  },
];

export const CarouselLEP = () => {
  return <CarouselShared slides={slides} textFirst={false} />;
};